import { Box } from '@mui/material';
import Autosuggest from 'components/controls/Autosuggest';
import { array, object, string } from 'prop-types';
import React, { useEffect } from 'react';
import { I18n } from 'utils/i18n';
import connector from './connector';

const Scope = ({
  actions,
  scopes: { scopes, loading },
  value,
  filter = null,
  filterOut = null,
  ...props
}) => {
  useEffect(() => {
    if (!scopes.length) actions.config.scopes.loadScopes();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- load scopes once on mount
  }, []);

  let filteredScopes = filter
    ? scopes.filter(sc => value === sc || filter.includes(sc)) || scopes
    : scopes;

  filteredScopes = filterOut
    ? filteredScopes.filter(sc => value === sc || !filterOut.includes(sc))
    : filteredScopes;

  return (
    <Box sx={{ width: '100%' }}>
      <Autosuggest
        {...props}
        fullWidth
        value={value}
        placeholder={loading ? I18n.t('Scope.Loading scopes...') : I18n.t('Scope.Choose scope')}
        suggestions={filteredScopes.map(scope => ({
          label: scope,
          value: scope,
        }))}
      />
    </Box>
  );
};

Scope.propTypes = {
  actions: object.isRequired,
  value: string.isRequired,
  filter: array,
  filterOut: array,
  scopes: object.isRequired,
};

export default connector(Scope);
